import { SearchModeService, } from '@/plugins/search-mode/search-mode-service';
import type { SearchMode } from '@/types/init';
import { computed, ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';

function composable() {
    const service = injectService<SearchModeService>(SearchModeService);

    const searchMode = ref<SearchMode>('unset');

    const hasGetSearchMode = ref(false);

    const isFamilyDb = computed(() => {
        return searchMode.value === 'family';
    });

    service.searchMode.then((mode) => {
        searchMode.value = mode;
    });

    service.onChangeMode(({ mode, hasGetSearchMode: _hasGetSearchMode }) => {
        console.log('hasGetSearchMode', _hasGetSearchMode);
        hasGetSearchMode.value = _hasGetSearchMode;
        searchMode.value = mode;
    });

    async function updateSearchMode(mode: SearchMode) {
        return service.updateSearchMode(mode);
    }

    async function getSearchModes() {
        return service.getSearchModes();
    }

    return {
        /**
         * 搜索模式, 默认为 publication, 可选值为 publication | family
         */
        searchMode,
        /**
         * 是否为同族库模式
         */
        isFamilyDb,
        /**
         * 更新搜索模式, 会触发 onChangeMode 事件
         */
        updateSearchMode,
        /**
         * 获取搜索模式列表，会触发 onChangeMode 事件
         */
        getSearchModes,
    }
}

export const useSearchMode = createGlobalState(composable);
